import { useState, useEffect } from "react";
import { API_BASE } from "../config";
import "../styles/LoadingOverlay.css";

export default function LoadingOverlay({ message = "Loading…" }) {
  const [owls, setOwls]       = useState([]);
  const [current, setCurrent] = useState(0);
  const [phase, setPhase]     = useState("in");

  useEffect(() => {
    try {
      const cached = localStorage.getItem("owlCache");
      if (cached) {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed) && parsed.length) setOwls(parsed);
      }
    } catch {}
  }, []);

  useEffect(() => {
    if (!owls.length) return;
    let t;
    if (phase === "in")   t = setTimeout(() => setPhase("hold"), 400);
    if (phase === "hold") t = setTimeout(() => setPhase("out"),  3500);
    if (phase === "out")  t = setTimeout(() => { setCurrent(c => (c + 1) % owls.length); setPhase("in"); }, 400);
    return () => clearTimeout(t);
  }, [phase, owls.length]);

  const owl = owls[current];
  const DEFAULT_OWL = `${process.env.PUBLIC_URL}/images/owlTestImgNoBG.png`;

  return (
    <div className="loading-screen">
      <div className="lo-content">
        {owl ? (
          <div className={`lo-spotlight lo-spotlight--${phase}`}>
            <img
              src={owl.image_url ? `${API_BASE}${owl.image_url}` : DEFAULT_OWL}
              alt={owl.name}
              className="lo-owl-img"
            />
            <span className="lo-owl-name">{owl.name}</span>
          </div>
        ) : (
          <div className="lo-spotlight lo-spotlight--hold">
            <img src={DEFAULT_OWL} alt="Owllet" className="lo-owl-img lo-owl-img--default" />
          </div>
        )}
        <p className="lo-message">{message}</p>
      </div>
    </div>
  );
}
